import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import DEVICES from '../../common/styles/devices';
import { CustomMessageProps } from './utils';

export const BlueWrapper = styled.div`
  width: 100%;
  height: 189px;
  background-color: ${COLORS.dividerBlue};
  display: flex;
  justify-content: center;
  @media ${DEVICES.mobileXL} {
    width: 100% !important;
  }
`;
export const MainHelpCenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  z-index: 9999;
  @media ${DEVICES.mobileXL} {
    width: 100% !important;
  }
`;
export const TextWrapper = styled.div`
  margin: 0 auto;
  height: 100%;
  width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Text = styled.div`
  display: flex;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  line-height: 38px;
  justify-content: space-between;
  align-items: center;
  color: ${COLORS.black};

  @media ${DEVICES.mobileXL} {
    width: unset;
    margin: 0 24px;
  }
`;
export const SubText = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.textGrey};
  @media ${DEVICES.mobileXL} {
    margin: 0 24px;
  }
`;
export const SearchWrapper = styled.div`
  margin-top: -40px;
  max-width: 450px;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
export const BorderedSearch = styled.div`
  min-width: 100%;
  border-radius: 8px;
  background-color: ${COLORS.white};
  display: flex;
  align-items: center;
  position: relative;
  padding: 24px;
  box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.1);
  > input {
    color: ${COLORS.black};
    width: 100%;
    border: 0;
    height: 1.1875em;
    margin: 0;
    display: block;
    padding: 6px 0 7px;
    min-width: 0;
    background: none;
    box-sizing: content-box;
    align-self: center;
    margin-left: 10px;
    font-size: 1rem;
    box-sizing: border-box;
    align-items: center;
    font-family: ${FONT_FAMILY.hellix.regular};
    ::placeholder {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 16px;
      letter-spacing: normal;
      text-transform: none;
      color: ${COLORS.textLightGrey} !important;
    }
  }
  .search-icon {
    margin-bottom: 2px;
  }
  @media ${DEVICES.mobileXL} {
    min-width: unset;
    margin: 20px;
  }
`;
export const SelectDataWrapper = styled.div`
  cursor: pointer;
  :hover {
    background: ${COLORS.lightBlueDark};
  }
  .fLagIcon {
    height: 24px;
    width: 24px;
  }
  .multiSelect-search {
    display: flex;
    align-items: center;
  }
`;
export const BrowseWrapper = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 24px;
  margin-top: 48px;
  color: ${COLORS.black};
  @media ${DEVICES.mobileXL} {
    margin: 0 20px;
  }
`;
export const QueryWrapper = styled.div`
  margin-top: 24px;
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  margin-bottom: 40px;
  width: 450px;
  @media ${DEVICES.mobileXL} {
    width: unset;
    margin: 24px 20px;
  }
`;
//Queries

export const SubLevel = styled.div<{ $isSearch?: boolean }>`
  border-bottom: 1px solid ${COLORS.grey200};
  display: flex;
  flex-direction: ${({ $isSearch = false }) => ($isSearch ? 'column' : 'row')};
  justify-content: flex-start;
  margin: 0 16px;
  align-items: center;
  color: ${COLORS.textGrey};
  cursor: pointer;
  @media ${DEVICES.mobileXL} {
    margin: 0px 10px 0px 10px;
  }
  .options {
    display: flex;
  }
  .tags {
    display: flex;
  }
`;

export const QueryCardWrapper = styled.div`
  width: 100%;
  margin: 24px 16px;
`;

type OptionsTextProps = {
  $fontSize?: number;
  $customPadding?: string;
};

export const OptionsText = styled.div<OptionsTextProps>`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
  line-height: 24px;
  padding: ${({ $customPadding }) => ($customPadding ? $customPadding : '24px 16px')};
  :hover {
    cursor: pointer;
  }
  .classification {
    color: ${COLORS.textLightGrey};
    line-height: 22px;
    font-size: 12px;
  }
`;
export const ForwardArrowSymbol = styled.div`
  color: ${COLORS.textLightGrey};
  margin-left: auto;
`;
export const ImageStart = styled.div`
  :hover {
    cursor: pointer;
  }
`;
export const TicketCardWrapper = styled.div`
  margin-top: 24px;
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  @media ${DEVICES.mobileXL} {
    margin: 0 20px;
  }
`;
export const SubTextTicket = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.textLightGrey};
`;
export const TicketWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
`;
export const CreatedAtWrapper = styled.div`
  color: ${COLORS.textLightGrey};
  margin-left: auto;

  ${DEVICES.mobileXL} {
    margin-left: 16px;
  }
`;
export const HeaderTicket = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  line-height: 26px;
  color: ${COLORS.black};
  max-width: 320px;

  @media ${DEVICES.mobileXL} {
    max-width: 200px;
  }
`;
export const OpenTicketsWrapper = styled.div<{ $show?: boolean }>`
  display: ${({ $show }) => ($show ? 'none' : 'block')};
`;
export const OpenTicketsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 24px;
  margin-top: 48px;
  color: ${COLORS.black};
  @media ${DEVICES.mobileXL} {
    margin: 24px 20px;
  }
`;
export const Divider = styled.div`
  height: 6px;
  background: linear-gradient(180deg, #eee 0%, #fafafa 100%);
  margin: 48px 0;
`;

export const BreadcrumbItem = styled.span`
  text-align: center;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 12px;
`;

export const BreadcrumbItemContainer = styled.div`
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: left;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 12px;
  padding: 24px 16px 0 16px;
  color: ${COLORS.textDarkGray};
`;

export const QueryItemTextContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const SubListItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  align-self: stretch;
  .sub-list-item {
    padding: 24px 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: flex;
    border-bottom: 1px solid ${COLORS.borderGrey};
    cursor: pointer;
  }
  .__title {
    color: ${COLORS.textGrey};
    line-height: 22px;
    font-size: 16px;
    max-width: 420px;
  }
`;

export const SubListHeader = styled.span`
  font-size: 28px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 38px;
  text-align: left;
  @media ${DEVICES.mobileXL} {
    font-size: 24px;
  }
`;

export const ArticleCountView = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: ${COLORS.lightBlueBackground};
  border-radius: 8px;
  border: 1px solid ${COLORS.lightBlueBackground};
  padding: 4px 12px;
  gap: 8px;
  .count-text {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 12px;
    line-height: 22px;
    color: ${COLORS.textGrey};
  }
  .article-info-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
`;

export const ArticleContentView = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  justify-content: flex-start;
  align-items: flex-start;
  .textGrayColor {
    color: ${COLORS.textGrey};
  }
  .linkTextColor {
    color: ${COLORS.darkBlue};
  }
  .underLineCSS {
    text-decoration-line: underline;
  }
  .italicCSS {
    font-style: italic;
  }
  .smallFont {
    font-size: 16px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.regular};
  }
  .smallBoldFont {
    font-size: 16px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .MB16 {
    margin-bottom: 16px;
  }
  .headingStyle {
    margin-bottom: 12px;
    margin-top: 12px;
    color: ${COLORS.black};
    text-align: left;
  }
  .xxxLargeBoldFont {
    font-size: 34px;
    line-height: 46px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .xxLargeBoldFont {
    font-size: 28px;
    line-height: 40px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .xLargeBoldFont {
    font-size: 24px;
    line-height: 36px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .largeBoldFont {
    font-size: 22px;
    line-height: 30px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .mediumBoldFont {
    font-size: 18px;
    line-height: 28px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .smallBoldFont24Height {
    font-size: 16px;
    line-height: 24px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .alignSelfFlexStart {
    align-self: flex-start;
    display: flex;
  }
  .darkColor {
    color: ${COLORS.black};
  }
  .ML10 {
    margin-left: 10px;
  }

  ::-webkit-scrollbar {
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.textDarkGray};
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.lightShadedGrey};
  }
  .table-container {
    width: 450px;
    overflow-x: auto;
  }
  table,
  th,
  td {
    border: 1px solid ${COLORS.textDarkGray};
    border-collapse: inherit;
    align-items: center;
  }
  td,
  th {
    padding: 16px;
  }

  .list-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    .list-item-bullet {
      margin-right: 4px;
    }
  }
  .image-asset-container {
    max-width: 450px;
    overflow-x: auto;
  }

  @media ${DEVICES.mobileXL} {
    width: 400px;
    .table-container,
    .image-asset-container,
    .smallFont {
      width: 350px !important;
    }
  }
  @media ${DEVICES.mobileM} {
    width: 350px;
    .table-container,
    .image-asset-container,
    .smallFont {
      width: 300px !important;
    }
  }
  @media ${DEVICES.mobileS} {
    width: 300px;
    .table-container,
    .image-asset-container,
    .smallFont {
      width: 250px !important;
    }
  }
`;

export const ArticleBottomView = styled.div`
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 24px;
  .bottom-section-heading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 12px;
    line-height: 22px;
    color: ${COLORS.textGrey};
  }
  .disabled-button {
    pointer-events: none !important;
    cursor: not-allowed !important;
    color: ${COLORS.textDarkGray} !important;
  }
`;

export const SubListBreadCrumbContainer = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .bread-crumb-item {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 14px;
    line-height: 26px;
    color: ${COLORS.textDarkGray};
  }
`;

export const ArticleInnerDiv = styled.div`
  @media ${DEVICES.mobile} {
    ::-webkit-scrollbar {
      display: none;
    }
    max-height: ${window.innerHeight - 300}px;
    overflow-y: auto;
  }
`;
export const SubListMainContainer = styled.div`
  width: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: start;
  flex-direction: column;
  margin: 36px auto;
  .sub-list-back-arrow {
    height: 24px;
    width: 24px;
    cursor: pointer;
    position: absolute;
    margin-left: -150px;
    margin-top: 30px;
  }
  .top-section-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
    padding: 0 20px;
    .sub-list-back-arrow {
      position: relative;
      margin: 0 0 24px -5px;
    }
  }
  @media (min-width: 551px) and (max-width: 768px) {
    .sub-list-back-arrow {
      position: relative;
      margin: 0 0 24px 0 !important;
    }
  }
`;
export const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 52px 0;
  @media ${DEVICES.mobileXL} {
    padding: 0 16px;
  }
`;

export const AllTicketsHeaderContainer = styled.div`
  width: 450px;
  gap: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0;
  flex-direction: column;
  button {
    width: 130px !important;
  }
  .back-arrow {
    height: 24px;
    width: 24px;
    cursor: pointer;
    position: absolute !important;
    margin-left: 150px;
    margin-top: 10px;

    @media ${DEVICES.mobileToTabletXL} {
      margin-left: 0;
    }
  }
  .header-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .__heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      font-weight: 700;
      line-height: 38px;
    }
  }
  .__sub-heading {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
    .back-arrow {
      position: relative !important;
      margin: 10px 4px 24px -5px;
    }
  }
`;

export const TicketCategoryContainer = styled.div`
  margin-top: 36px;
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;

export const Option = styled.span<{ isActive: boolean }>`
  cursor: pointer;
  font-family: ${({ isActive = false }) =>
    isActive ? FONT_FAMILY.hellix.bold : FONT_FAMILY.hellix.regular};
  font-size: 18px;
  color: ${({ isActive }) => (isActive ? COLORS.brandPrimary : COLORS.textLightGrey)};
  font-weight: ${({ isActive }) => (isActive ? 700 : 400)};
  line-height: 26px;
  border-bottom: ${({ isActive }) => (isActive ? `3px solid ${COLORS.brandPrimary}` : 'none')};
`;

export const TicketHistoryContainer = styled.div`
  margin-top: 36px;

  width: 450px;
  border-radius: 8px;
  max-height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border: 1px solid ${COLORS.borderGrey};
  ::-webkit-scrollbar {
    width: 4px;
  }
  overflow-y: auto;
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.borderGrey};
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.lightShadedGrey};
  }
  @media ${DEVICES.mobileXL} {
    width: 100%;
    max-height: calc(100vh - 300px);
  }
`;

export const ArticlePageTransactionHistory = styled.div`
  .transaction-history {
    .table {
      .desktop-list-wrapper {
        overflow-x: hidden !important;
      }
    }
  }
`;

//ActiveChat

export const ActiveChatWrapper = styled.div`
  cursor: pointer;
  width: 335px;
  border: 1px solid ${COLORS.lightborderBlue};
  background-color: ${COLORS.lightBlueBackground};
  padding: 16px;
  border-radius: 8px;
  z-index: 99999;
  bottom: 42px;
  right: 42px;
  float: right;
  position: fixed;
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
  box-shadow: 0 10px 24px 0 ${COLORS.boxShadowBlackShade};
  .display-flex {
    display: flex;
  }
  .display-center {
    justify-content: center;
    align-items: center;
  }
  @media ${DEVICES.mobileXL} {
    width: 100% !important;
    border-radius: 8px 8px 0 0;
    bottom: 0;
    right: 0;
    float: none;
  }
`;

export const OngoingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 215px;
  white-space: pre;
`;

export const Heading = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.black};
`;

export const SubHeading = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 16px;
  width: 100%;
  color: ${COLORS.textGrey};
`;

export const HorizontalDivider = styled.div`
  width: 2px;
  background: ${COLORS.lightborderBlue};
  margin: 0 16px;
`;

export const RatingUIContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`;

type RatingButtonsContainerProps = {
  isSelected?: boolean;
};

export const RatingButtonsContainer = styled.div<RatingButtonsContainerProps>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  padding: 12px 16px;
  border: ${({ isSelected = false }) =>
    `1px solid ${isSelected ? COLORS.brandPrimary : COLORS.textGrey}`};

  border-radius: 1000px;
  .icon {
    width: 24px;
    height: 24px;
  }
  .__text {
    font-size: 16px;
    color: ${({ isSelected = false }) => (isSelected ? COLORS.brandPrimary : COLORS.textGrey)};
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 24px;
  }
`;
export const TicketDelayWrapper = styled.div<CustomMessageProps>`
  width: ${({ width = 450 }) => width}px;
  padding: 48px 0 0;
  align-self: ${({ alignSelf = 'inherit' }) => alignSelf};
  .container {
    width: 100%;
    padding: 12px 16px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid ${COLORS.borderGrey};
    background-color: ${COLORS.lightShadedGrey};
    display: grid;
    justify-content: center;
    align-items: start;
    grid-template-columns: 1fr 19fr;
    .icon {
      width: 24px;
      height: 24px;
    }
    .message-text {
      width: 100%;
      color: ${COLORS.textGrey};
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
    }
  }
  @media ${DEVICES.mobileXL} {
    width: 100% !important;
    padding: ${({ mobilePadding = '0' }) => mobilePadding};
  }
`;

export const ChatRow = styled.div`
  padding: 16px 0 36px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.borderGrey};
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.lightShadedGrey};
  }
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
export const Chat = styled.div`
  display: flex;
  flex-direction: column;
`;
export const LineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 8px 10px 16px;
  width: 420px;
  @media ${DEVICES.mobileXL} {
    width: unset;
  }
`;
export const ImageIcon = styled.div`
  margin-right: 10px;
  margin-top: 3px;
  .customer-img {
    height: 24px;
    width: 24px;
  }
`;
export const ChatData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  max-width: 250px;
  .userattachments {
    display: flex;
    flex-direction: row;
    row-gap: 20px;
    flex-wrap: wrap;
  }
  .noPreviewAvailable {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 112px;
    width: 80px;
  }
  .downloadContainer {
    display: inline-flex;
    align-items: flex-end;
    margin: 5px;
    position: relative;
    border: 1px solid ${COLORS.black};
    border-radius: 4px;
    .download {
      background: ${COLORS.borderGrey};
      padding: 5px !important;
      position: absolute;
      left: 50%;
      border-radius: 50px !important;
      transform: translate(-50%, 50%);
      .download-icon {
        height: 16px;
        width: 16px;
      }
    }
    .preview {
      img {
        width: 70px;
        height: 50px;
      }
      .noPreviewFileName {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 80px;
      }
    }
  }
`;
export const AuthorDate = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 3px;
`;
export const Author = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 12px;
  line-height: 16px;
  margin-right: 5px;
`;
export const ChatDate = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.textDarkGray};
  margin-left: 5px;
`;
export const ChatLine = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.borderGrey};
  padding: 12px;
  border-radius: 10px;
  margin-top: 5px;
  width: fit-content;
  .zd-comment {
    a {
      color: ${COLORS.darkBlue};
      font-family: ${FONT_FAMILY.hellix.bold};
    }
    p {
      font-size: 14px;
    }
  }
  .chatTxt {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    line-height: 22px;
    word-break: break-word;

    strong {
      font-family: ${FONT_FAMILY['default']['bold']} !important;
    }
    em {
      font-style: italic !important;
    }
    img {
      max-height: 112px;
    }
    table {
      @media screen and (max-width: 700px) {
        min-width: 250px !important;
      }
    }
  }
`;

export const AddChatRow = styled.div`
  width: 100%;
  .status {
    margin: 10px 0 20px 10px;
  }
  .complete-img {
    margin: 5px;
    @media ${DEVICES.mobileXL} {
      text-align: center;
    }
  }
`;
export const MessageDivider = styled.div`
  border-top: 2px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 4px 0 ${COLORS.boxShadowBlackShade};
`;
export const NewChatWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 24px 16px 24px 0;
`;
export const ChatInputTextBox = styled.div`
  margin: 0px 5px;
  .new-chat-input {
    width: 100%;
    border: none;
  }
  .text-area-wrapper {
    margin: 0px 0px 10px 0px;
    textarea {
      border: 0px;
      padding: 0px 0px 0px 10px;
      font-size: 15px;
      line-height: 18x;
      ::-webkit-input-placeholder {
        font-size: 15px;
        color: ${COLORS.textDarkGray} !important;
        padding: 0px 0px 5px 5px;
      }
      resize: none;
    }
  }
`;
export const AddChat = styled.div`
  margin: 10px 0px 9px 15px;
  .addchat-send {
    :hover {
      cursor: pointer;
    }
    background: none;
    border: 0px;
    img {
      width: 15px;
      height: 15px;
      float: right;
      margin-right: 0px;
    }
  }
`;
export const ImageContainer = styled.div`
  margin: 10px 0px 10px 10px;
  .multiUploadContainer {
    img {
      height: 15px;
    }
  }
  :hover {
    cursor: pointer;
  }
`;

export const ChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 200px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.borderGrey};
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.lightShadedGrey};
  }
`;

export const ConversationContainer = styled.div`
  margin-top: 36px;
  width: 450px;
  border-radius: 8px;
  max-height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid ${COLORS.borderGrey};
  ::-webkit-scrollbar {
    width: 4px;
    margin-left: 16px;
  }
  overflow-y: auto;
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.borderGrey};
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.lightShadedGrey};
  }
  @media ${DEVICES.mobileXL} {
    max-height: calc(100vh - 300px);
    width: 100%;
  }
`;

export const HeadingRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 450px;
  .back-img {
    height: 24px;
    width: 24px;
    cursor: pointer;
    left: 20pc;
    margin-top: -58px;
    position: absolute;
  }
  @media ${DEVICES.laptopL} {
    .back-img {
      left: 7pc;
    }
  }

  @media ${DEVICES.tab} {
    .back-img {
      left: 1pc;
    }
  }

  @media ${DEVICES.tablet} {
    .back-img {
      left: 7pc;
    }
  }

  @media ${DEVICES.mobileXL} {
    display: flex;
    width: 100%;
    .back-img {
      left: 0;
      margin: 0 0 24px -5px;
      position: relative;
    }
  }
`;

export const Header = styled.div`
  width: 450px;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.materialUiTextFieldColor};
  margin-bottom: 5px;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;

export const DetailsWrapper = styled.div`
  color: ${COLORS.textLightGrey};
  display: flex;
  font-size: 15px;
  font-weight: 400;
  flex-direction: row;
  line-height: 18px;
  margin-bottom: 5px;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;

export const TicketNumber = styled.div`
  color: ${COLORS.textLightGrey};
`;
export const TicketDate = styled.div`
  margin-left: 5px;
`;

export const DisputeStatusWrapper = styled.div<{ $color: string }>`
  text-align: center;
  padding: 16px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 26px;
  color: ${({ $color }) => $color};
`;
